import { Modal } from "antd"
import { ReactNode } from "react"
import PayInvoice from "./PayInvoice"
import { toMarkPaidManuallyRequest } from "./payInvoiceModel"
import { useGetPaymentStatusQuery, useInvoiceDetailsQuery, useMarkInvoicePaidManuallyMutation } from "../../../domain/invoicing/invoicingQueries"
import { usePayDocument } from "./usePayDocument"

export type Props = {
  isOpen: boolean
  onClose: () => void
  invoiceId: string
  customerId: number
  notice?: ReactNode
}

const PayInvoiceModal = ({ isOpen, onClose, invoiceId, customerId, notice }: Props) => {
  const paymentStatusQuery = useGetPaymentStatusQuery(invoiceId, { disabled: !isOpen })
  const detailsQuery = useInvoiceDetailsQuery(invoiceId)
  const markPaidManuallyMutation = useMarkInvoicePaidManuallyMutation()

  const pay = usePayDocument({
    isOpen,
    onClose,
    customerId,
    documentLabel: 'Invoice',
    paymentStatusQuery,
    markPaidManuallyMutation,
    buildMarkPaidRequest: (state) => toMarkPaidManuallyRequest(invoiceId, state)
  })

  const invoiceTotal = detailsQuery.data?.invoice.total ?? 0

  return <Modal
    open={isOpen}
    okText="Submit"
    okButtonProps={{ disabled: pay.submitDisabled || detailsQuery.isLoading, loading: pay.isSubmitting }}
    onOk={pay.handleSubmit}
    onCancel={onClose}
    title="Pay Invoice"
    width={800}
  >
    {isOpen && <>
      {notice && <div style={{ marginBottom: 16 }}>{notice}</div>}
      <PayInvoice
        invoiceTotal={invoiceTotal}
        isLoading={pay.isLoading || detailsQuery.isLoading}
        isError={pay.isError}
        status={pay.paymentStatus}
        paymentMethods={pay.paymentMethods}
        payInvoiceState={pay.payState}
        setPayInvoiceState={pay.setPayState}
        paymentPageUrl={detailsQuery.data?.paymentPageUrl ?? ''}
      />
    </>}
  </Modal>
}

export default PayInvoiceModal
